import { View } from 'react-native';
export const NativeScreenContainer = View;
export const NativeScreenNavigationContainer = View;
export default View;
//# sourceMappingURL=ScreenContainer.web.js.map